export default {
	id: 122431,
	name: 'Chad',
	lastname: 'Tester',
	address: 'Nobelvägen',
	careof: null,
	zipcode: '42332',
	city: 'MALMÖ',
	country: 'Sverige',
	email: 'jonas.dahlin@nordicmorning.com',
	phone: '',
	secondphone: '',
	mobilephoneprefix: '+46',
	mobilephone: '34345345',
	password: null,
	force: null,
	headlid: null,
	update_skipass: null,
	facebookkey: null,
	guests: [
		{
			guestlid: 122451,
			addrclid: 122431,
			name: 'Daniel',
			lastname: 'Ungdom',
			phoneprefix: '33',
			phone3: '3333333',
			birthdate: '2006-04-03',
			age: 14,
			length: 33,
			weight: 33,
			shoesize: 33,
			headsize: 0,
			keynumber: ''
		},
		{
			guestlid: 122452,
			addrclid: 122431,
			name: 'Emma',
			lastname: 'Vuxen',
			phoneprefix: '33',
			phone3: '3333333',
			birthdate: '2000-04-03',
			age: 20,
			length: 33,
			weight: 33,
			shoesize: 33,
			headsize: 0,
			keynumber: '01-1614 7133 5346 1418 3973-7'
		},
		{
			guestlid: 122453,
			addrclid: 122431,
			name: 'Dalle',
			lastname: 'Senior',
			phoneprefix: '33',
			phone3: '3333333',
			birthdate: '1952-04-03',
			age: 68,
			length: 33,
			weight: 33,
			shoesize: 33,
			headsize: 0,
			keynumber: '01-1614 7133 5346 1418 3973-7'
		},
		{
			guestlid: 122454,
			addrclid: 122431,
			name: 'Saga',
			lastname: 'Barn',
			phoneprefix: '33',
			phone3: '3333333',
			birthdate: '2018-04-03',
			age: 2,
			length: 33,
			weight: 33,
			shoesize: 33,
			headsize: 0,
			keynumber: '01-1614 7133 5346 1418 3973-7'
		},
		{
			guestlid: 122455,
			addrclid: 122431,
			name: 'John',
			lastname: 'No size',
			phoneprefix: '33',
			phone3: '3333333',
			birthdate: '1993-04-03',
			age: 27,
			length: 0,
			weight: 0,
			shoesize: 0,
			headsize: 0,
			keynumber: '01-1614 7133 5346 1418 3973-7'
		}
	],
	tokenObject: {
		accessToken:
			'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjEyMjQzMSIsIm5iZiI6MTYwMDc3NzU4MSwiZXhwIjoxNjAwNzc4NDgxLCJpc3MiOiJLbGFwcGVuIiwiYXVkIjoiRXZlcnlvbmUifQ.CQOm66RU4eZRDSkWVYLTdix02BbU-VtNf2FDpi0MM3I',
		refreshToken: 'isJBb1guVQ3gJP9v7U14lT6iEqNkbZXuK/g31P24k3k=',
		accessTokenExpiration: '2020-09-22T14:41:21.27506+02:00'
	}
}
